<template>
  <div class="handSwitchLogs-container">
    <el-row>
      <el-form inline :model="queryForm" ref="queryForm" @submit.native.prevent>
        <el-form-item class="r-20" prop="plateNum">
          <el-input
            placeholder="车牌号"
            @keyup.enter.native="query"
            v-model.trim="queryForm.plateNum"
          ></el-input>
        </el-form-item>
        <el-form-item class="r-20" prop="name">
          <el-input
            placeholder="车辆绑定人"
            @keyup.enter.native="query"
            v-model.trim="queryForm.name"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item class="r-20" prop="openPowerId">
          <el-select v-model="queryForm.openPowerId" placeholder="操作内容">
            <el-option
              v-for="item in openPowerOptions"
              :key="item.id"
              :label="item.label"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item class="r-20" prop="user">
          <el-input
            placeholder="操作用户"
            @keyup.enter.native="query"
            v-model.trim="queryForm.user"
          ></el-input>
        </el-form-item>
        <el-form-item class="r-20" prop="time">
          <el-date-picker
            v-model="queryForm.time"
            type="date"
            placeholder="操作日期"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item class="r-20">
          <el-button type="primary" @click="query">查询</el-button>
          <el-button @click="reset">取消</el-button>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row>
      <el-table
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        size="mini"
        stripe
        height="560px"
      >
        <el-table-column width="20"></el-table-column>
        <el-table-column type="index" label="序号" width="70"></el-table-column>
        <el-table-column
          label="车牌号"
          prop="plateNum"
          min-width="100"
        ></el-table-column>
        <el-table-column
          label="车辆绑定人"
          prop="name"
          min-width="100"
        ></el-table-column>
        <el-table-column
          label="联系电话"
          prop="phone"
          min-width="140"
        ></el-table-column>
        <el-table-column label="开关操作" min-width="160" prop="switchStatus">
          <template slot="header">
            <span>开关操作</span>
            <i class="iconfont icon-sort" @click="powerStatusChange"></i>
          </template>
          <template slot-scope="{ row }">
            <span v-if="row.switchStatus == 2">关闭发电服务</span>
            <span v-if="row.switchStatus == 1">开启发电服务</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作内容"
          prop="operationContent"
          min-width="200"
        >
          <template slot-scope="{ row }">
            <span>{{ powerChange(row.operationContent) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作时间"
          prop="operationTime"
          min-width="200"
        ></el-table-column>
        <el-table-column
          label="操作用户"
          prop="account"
          min-width="100"
        ></el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="limit"
        layout="total, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "HandSwitchLogs",
  data() {
    return {
      queryForm: {
        plateNum: "",
        name: "",
        user: "",
        openPowerId: "",
        time: "",
      },
      switchStatus: "",
      currentPage: 1,
      limit: 10,
      total: 0,
      tableData: [],
      openPowerOptions: [
        { id: 1, label: "立即关闭" },
        { id: 2, label: "自定义" },
        { id: 3, label: "24小时" },
        { id: 4, label: "48小时" },
        { id: 5, label: "发电功能开启异常" },
        { id: 6, label: "测试发电功能" },
        { id: 7, label: "应急抢险救灾" },
      ],
      pickerOptions: {
        disabledDate(date) {
          return date.getTime() > Date.now();
        },
      },
    };
  },
  created() {
    this.getTableData();
  },
  computed: {
    powerChange() {
      let content = "";
      return function(type) {
        switch (type) {
          case 1:
            content = "立即关闭";
            break;
          case 2:
            content = "自定义";
            break;
          case 3:
            content = "24小时";
            break;
          case 4:
            content = "48小时";
            break;
          case 5:
            content = "发电功能开启异常";
            break;
          case 6:
            content = "测试发电功能";
            break;
          case 7:
            content = "应急抢险救灾";
            break;
        }
        return content;
      };
    },
  },
  methods: {
    powerStatusChange() {
      // 筛选开启/关闭
      this.switchStatus = this.switchStatus == 1 ? 2 : 1;
      this.getTableData();
    },
    query() {
      console.log(this.queryForm);
      this.getTableData();
    },
    reset() {
      this.$resetForm(this, "queryForm");
      this.switchStatus = "";
      this.getTableData();
    },
    //pagesize改变时触发
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    //页数改变时触发
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.getTableData();
    },
    async getTableData() {
      let obj = {};
      obj.plate = this.queryForm.plateNum;
      obj.name = this.queryForm.name;
      obj.operationContent = this.queryForm.openPowerId;
      obj.account = this.queryForm.user;
      obj.operationTime = this.queryForm.time;
      obj.switchStatus = this.switchStatus;
      obj.page = this.currentPage;
      obj.limit = this.limit;
      let { data: res } = await this.$axios.get("/api/vehicle/manualOpenList", {
        params: obj,
      });
      if (res.code == 1) {
        this.tableData = res.data.list;
        this.total = res.data.totalCount;
      } else {
        this.$message.warning(res.msg);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.handSwitchLogs-container {
  height: calc(100% - 80px);
  margin: 20px;
  padding: 20px;
  background: #fff;

  .iconfont {
    margin-left: 5px;
  }

  ::v-deep .el-form {
    .el-input {
      width: 220px;
      .el-input__inner {
        width: 220px;
        padding-left: 15px;
      }
      .el-input__prefix {
        left: auto;
        right: 5px;
        color: #333;
      }
      .el-input__suffix {
        .el-input__icon.el-icon-circle-close {
          display: none;
        }
      }
      // .el-icon-arrow-up:before{
      //   content: '、';
      // }
    }
  }
}
</style>
